import React from "react";

import Box from "@/ui/atoms/Box";

import type { TDealView, TUserDatabase } from "@/apis/odin/apiODIN";
import Typography from "@/ui/atoms/Typography";
import { useParams } from "react-router-dom";
import type { IconProp } from "@proda-ai/ui-kit";
import CollapsedText from "@/ui/atoms/CollapsedText";

export type ViewBreadcrumbsParams = {
    useState: () => {
        selectedDatabases: TUserDatabase[] | null;
        allProjects: TDealView[] | null;
    };
};

type BreadcrumbItem = {
    name: string;
    icon?: IconProp;
};

export const createViewBreadcrumbs = ({ useState }: ViewBreadcrumbsParams) => {
    const ViewBreadcrumbs = () => {
        const { selectedDatabases, allProjects } = useState();
        const { projectId } = useParams() as { projectId?: string };

        if (!selectedDatabases) {
            return null;
        }

        let breadcrumbs: BreadcrumbItem[] = [];

        if (selectedDatabases.length === 1) {
            breadcrumbs = [
                {
                    name: selectedDatabases[0]?.databaseName ?? "",
                    icon: "server",
                },
            ];
        } else {
            breadcrumbs = [
                {
                    name: `Viewing ${selectedDatabases.length} Databases`,
                    icon: "server",
                },
            ];
        }

        if (projectId !== undefined && projectId.trim() !== "") {
            const foundProject = allProjects?.find(
                deal => deal.dealInfo.projectId === parseInt(projectId),
            );
            if (foundProject) {
                breadcrumbs = [
                    ...breadcrumbs,
                    {
                        name: foundProject.dealInfo.dealName,
                        icon: "file-spreadsheet",
                    },
                ];
            }
        }

        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}
            >
                {breadcrumbs.map((crumb, idx) => (
                    <React.Fragment key={idx}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "var(--proda-orange-100)",
                                mx: "0.5rem",
                            }}
                        >
                            /
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <CollapsedText
                                text={crumb.name}
                                maxWidth={180}
                                icon={crumb.icon}
                                expanded={idx === breadcrumbs.length - 1}
                            />
                        </Box>
                    </React.Fragment>
                ))}
            </Box>
        );
    };
    return ViewBreadcrumbs;
};
